(()=>{'use strict';
const mobile=matchMedia('(max-width:749px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
const disclosures=new WeakMap();
function syncDisclosures(scope=document){
  scope.querySelectorAll('[data-wjm-disclosure]').forEach(detail=>{
    let state=disclosures.get(detail);
    if(!state){state={mobileOpen:false,mode:null};disclosures.set(detail,state);detail.addEventListener('toggle',()=>{if(mobile.matches&&state.mode==='mobile')state.mobileOpen=detail.open;});}
    const next=mobile.matches?'mobile':'desktop';
    if(state.mode===next)return;
    if(state.mode==='mobile')state.mobileOpen=detail.open;
    state.mode=next;detail.open=mobile.matches?state.mobileOpen:true;
  });
}
const watched=new WeakSet();
const observer='IntersectionObserver'in window?new IntersectionObserver(entries=>{
  entries.forEach(({target:video,isIntersecting})=>{
    if(isIntersecting){
      if(!video.getAttribute('src')&&video.dataset.wjAmbientVideo){video.src=video.dataset.wjAmbientVideo;video.load();}
      if(!document.hidden&&!reduced.matches&&!navigator.connection?.saveData)video.play().catch(()=>{video.controls=true;});
      else video.controls=true;
    }else video.pause();
  });
},{rootMargin:'100px',threshold:0.01}):null;
function init(scope=document){
  syncDisclosures(scope);
  scope.querySelectorAll('video[data-wj-ambient-video]').forEach(video=>{
    if(watched.has(video))return;watched.add(video);
    if(observer)observer.observe(video);else{video.src=video.dataset.wjAmbientVideo;video.controls=true;}
  });
}
mobile.addEventListener('change',()=>syncDisclosures());
document.addEventListener('shopify:section:load',event=>init(event.target));
document.addEventListener('visibilitychange',()=>{if(document.hidden)document.querySelectorAll('video[data-wj-ambient-video]').forEach(video=>video.pause());});
document.addEventListener('click',event=>{
  const link=event.target.closest('a[href^="#"]');
  if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  const root=link.closest('wj-pdp-v98,wj-pantalon,wj-falda,wj-comodo');
  if(!root)return;
  let id;try{id=decodeURIComponent(link.hash.slice(1));}catch{return;}
  const target=id&&document.getElementById(id);
  if(!target||!root.contains(target))return;
  let parent=target.closest('details');
  while(parent){parent.open=true;parent=parent.parentElement?.closest('details');}
  if(target.tagName==='DETAILS')target.open=true;
  if(link.hasAttribute('data-wjm-outfit')||target.tagName==='DETAILS'){
    event.preventDefault();target.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'start'});
    const focus=target.tagName==='DETAILS'?target.querySelector('summary'):target.querySelector('h2,h3');
    if(focus){if(!focus.hasAttribute('tabindex'))focus.tabIndex=-1;focus.focus({preventScroll:true});}
  }
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
})();
